import React, { Component } from 'react'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithDataDashboard } from '../../services/CABE';
import "../../css/inventory-style.css"
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch, AiOutlineBarChart } from "react-icons/ai";
import LoadingWindow from '../../components/LoadingWindow';
import { confirmCloseAlert } from '../../functions/alerts';
import { NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';
import { getDateFromReports } from '../../functions/dateFormat';
import ExcelDocument from '../../components/ExcelDocument';
import { getDataSet } from '../../functions/generateDataSetExcel';
import { Menu } from '../../components/Menu/Menu';
import '../../css/dashboard.css';

export default class MOH extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        Body: [],
        BodyFilter: [],
        flag: true
    }

    async getMOH() {
        this.ModalLoading.current.showState(true);
        const start = document.getElementById('startMOHDate').value
        const end = document.getElementById('endMOHDate').value

        if (start !== '' && end !== '') {
            const data = {
                Start: start,
                End: end,
                idCompany: Number(getValueCookie('CompanyId')) || 3
            }

            const result = await getInformationWithDataDashboard('/invoice/report/MOHV2', data)

            if (result.status.code === 1) {
                const months = Number(result.monthsInRange) || 1
                result.data.forEach(item => {
                    var InvCont = Number(item.InventarioContable) || 0
                    var TotalUnits = Number(item.TotalSales) || 0
                    var avgMonthlySales = months > 0 ? TotalUnits / months : 0
                    var res = avgMonthlySales > 0 ? InvCont / avgMonthlySales : 0

                    item.MOH = res
                    item.Validation = res < 0.5 ? 'Scare' : (res > 1 ? 'Excess' : 'Ok')
                });

                this.setState({ Body: result.data, BodyFilter: result.data })
            } else {
                this.setState({ Body: [], BodyFilter: [] })
            }

        } else {
            this.ModalLoading.current.showState(false);
            confirmCloseAlert('incorrect', 'Two dates are required for the information search')
        }
        this.ModalLoading.current.showState(false);
    }



    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }

    OrderMOH(option) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "ItemCode":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "ProductLineDesc":
                temporal = OrderArray(temporal, "ProductLineDesc", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "MOH":
                temporal = OrderArray(temporal, "MOH", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    searchMOH = e => {
        const search = e.target.value;
        const Products = this.state.Body.filter(item =>
            this.contains(item.ItemCode, search) ||
            this.contains(item.ProductLineDesc, search) ||
            this.contains(item.ItemCodeDesc, search)
        );
        this.setState({ BodyFilter: Products });
    }

    getMOHKPIs() {
        const data = this.state.BodyFilter;
        if (!data.length) return null;
        const total   = data.length;
        const scarce  = data.filter(r => r.Validation === 'Scare').length;
        const ok      = data.filter(r => r.Validation === 'Ok').length;
        const excess  = data.filter(r => r.Validation === 'Excess').length;
        return { total, scarce, ok, excess };
    }

    render() {
        const hasData = this.state.Body.length > 0;
        const kpis = hasData ? this.getMOHKPIs() : null;

        const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' };
        const inputStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', padding: '0.4rem 0.75rem', width: '100%' };

        const statusBadge = (v) => {
            const map = {
                Scare:  { bg: 'rgba(239,68,68,0.06)',   color: '#DC2626', border: '#FECACA' },
                Ok:     { bg: 'rgba(16,185,129,0.08)',  color: '#059669', border: '#A7F3D0' },
                Excess: { bg: 'rgba(245,158,11,0.08)', color: '#D97706', border: '#FDE68A' },
            };
            const s = map[v] || map['Ok'];
            return (
                <span style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}`, borderRadius: '6px', padding: '2px 8px', fontSize: '0.75rem', fontWeight: 700 }}>
                    {v}
                </span>
            );
        };

        const rowClass = (v) => v === 'Scare' ? 'status-danger' : v === 'Excess' ? 'status-warning' : 'status-success';

        return (
            <div className="dash-page container-fluid pb-5" style={{ paddingTop: '70px', minHeight: '100vh', background: '#F8FAFC' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineBarChart style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Month On Hand Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Compare inventory value against monthly sales — identify scarce or excess stock</p>
                    </div>
                    {hasData && (
                        <div style={{ marginLeft: 'auto' }}>
                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                {this.state.BodyFilter.length.toLocaleString('en-US')} items
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ padding: '1.5rem 0' }}>

                    {/* Controls */}
                    <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Date Range</span>
                        </div>
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="startMOHDate">Start Date</label>
                                    <input style={inputStyle} id="startMOHDate" type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="endMOHDate">End Date</label>
                                    <input style={inputStyle} id="endMOHDate" type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button onClick={() => this.getMOH()} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center' }}>
                                        <AiOutlineReload /> Load Data
                                    </button>
                                </div>
                                {hasData && (
                                    <div className="col-sm-12 col-md-3 d-flex justify-content-end">
                                        <ExcelDocument
                                            archname={'MOH ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                            sheetname={'MOH ' + getValueCookie('Company')}
                                            data={getDataSet(this.state.Body, ['Item Code', 'Product Line', 'Description', 'MOH', 'Validation'], ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'MOH', 'Validation'])}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* KPIs */}
                    {hasData && kpis && (
                        <div className="row g-3 mb-3">
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Total Items</div>
                                    <div className="metric-value">{kpis.total.toLocaleString('en-US')}</div>
                                    <div className="metric-change">Tracked SKUs</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-danger">
                                    <div className="metric-label">Scarce</div>
                                    <div className="metric-value">{kpis.scarce.toLocaleString('en-US')}</div>
                                    <div className="metric-change">MOH &lt; 0.5</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-success">
                                    <div className="metric-label">OK</div>
                                    <div className="metric-value">{kpis.ok.toLocaleString('en-US')}</div>
                                    <div className="metric-change">0.5 ≤ MOH ≤ 1</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-warning">
                                    <div className="metric-label">Excess</div>
                                    <div className="metric-value">{kpis.excess.toLocaleString('en-US')}</div>
                                    <div className="metric-change">MOH &gt; 1</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Table */}
                    {hasData && (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem' }}>
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Inventory Status</span>
                                <div style={{ position: 'relative', minWidth: '260px' }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                    <input type="text" autoComplete="off"
                                        placeholder="Search item code, line, description…"
                                        onChange={this.searchMOH}
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                </div>
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr>
                                            <th onClick={() => this.OrderMOH("ItemCode")} style={{ cursor: 'pointer' }}>
                                                Item Code <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
                                            </th>
                                            <th onClick={() => this.OrderMOH("ProductLineDesc")} style={{ cursor: 'pointer' }}>
                                                Product Line <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
                                            </th>
                                            <th>Description</th>
                                            <th className="text-end">On Hand (units)</th>
                                            <th className="text-end">Units Sold</th>
                                            <th className="text-center" onClick={() => this.OrderMOH("MOH")} style={{ cursor: 'pointer' }}>
                                                MOH <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
                                            </th>
                                            <th className="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilter.map((element, e) => (
                                            <tr key={e} className={rowClass(element.Validation)}>
                                                <td>{element.ItemCode}</td>
                                                <td>{element.ProductLineDesc}</td>
                                                <td>{element.ItemCodeDesc}</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(Number(element.InventarioContable) || 0))}</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(Number(element.TotalSales) || 0))}</td>
                                                <td className="text-center">{NumberFormat(pricesFormat(element.MOH))}</td>
                                                <td className="text-center">{statusBadge(element.Validation)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Empty state */}
                    {!hasData && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineBarChart style={{ fontSize: '3rem', opacity: 0.3, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Select a date range and click <strong>Load Data</strong> to view the report.</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
